import React, { useState } from "react";
import { Editor } from "@tinymce/tinymce-react";
import { ThreeDots } from "react-loader-spinner";
import config from "../../../src/configurations";
import { RICH_TEXT_EDITOR_PLUGINS } from "../../configurations/Constants";
const { TINY_MCE_ACCESS_KEY } = config;

function RichTextEditor({ displayString, setDisplayString }) {
  const [isEditorLoading, setIsEditorLoading] = useState(true);
  return (
    <div style={{ position: "relative", minHeight: 250 }}>
      {isEditorLoading && (
        <div className="d-flex justify-content-center align-items-center position-absolute w-100 h-100">
          <ThreeDots color="#00BFFF" height={80} width={80} />
        </div>
      )}
      <Editor
        apiKey={TINY_MCE_ACCESS_KEY}
        value={displayString}
        onEditorChange={(text) => setDisplayString(text)}
        init={{
          height: 250,
          menubar: false,
          selector: "#tinymce",
          branding: false,
          elementpath: false,
          plugins: RICH_TEXT_EDITOR_PLUGINS,
          toolbar:
            "undo redo | blocks | " +
            "bold italic underline | bullist forecolor backcolor " +
            "strikethrough | numlist outdent indent | " +
            "removeformat",
          content_style:
            "body { font-family:Helvetica,Arial,sans-serif; font-size:13px; color:gray; line-height:1; }",
          init_instance_callback: () => setIsEditorLoading(false),
        }}
      />
    </div>
  );
}

export default RichTextEditor;
